import React from 'react'
import CustomButton from '../Custom/CustomButton';

const ProjectCard = ({ item, index }) => {
	return (
		<div
			key={index}
			className="projectCard"
			data-aos={index % 3 === 0 ? "zoom-in-right" : index % 3 === 1 ? "zoom-in" : "zoom-in-left"}
			data-aos-offset="180"
		>
			<div className="projectInfo">
				<img src={item.img} alt={item.headline} />
				<span className="shade"></span>
				<h3 className="m-4 mb-2">{item.headline}</h3>
				<p className="mx-4 text-gray-400 text-sm" dangerouslySetInnerHTML={{ __html: item.summary }}></p>
			</div>
			<div className="links">
				{item.codelink && <CustomButton text="Code" theme="#00fffc" onHandle={() => window.open(item.codelink)} />}
				{item.livedemo && <CustomButton text="Visit" theme="#00fffc" onHandle={() => window.open(item.livedemo)} />}
				{item.videodemo && <CustomButton text="Video Demo" theme="#00fffc" onHandle={() => window.open(item.videodemo)} />}
				{item.filelink && <CustomButton text="Design" theme="#00fffc" onHandle={() => window.open(item.filelink)} />}
			</div>
		</div>
	);
};

export default ProjectCard